module.exports = __webpack_public_path__ + "ci_vendor_grafana.d1a51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_grafana.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_grafana.svg
// module chunks = main